<template>
    <div id="start_page">
        <v-card v-if="myData && naozajUlozit < 4" style="background-color: #E8F5E9;">
            <v-card-text>
                Hodnotenie je anonymné, odoslanie dotazníka je možné len raz.
            </v-card-text>
            <v-card-title v-if="myData.vyucujuci.length>0">
                <span>Vyučujúci </span> 
                <span v-if="myData.typ_dot == 'C'"> - cvičenie/seminár</span>   
                <span v-if="myData.typ_dot == 'P'"> - prednáška</span>                   
                (kliknutím vyberte):
                {{menoVyucujuci}}
            </v-card-title>
            <v-card-text>
                <v-row style = "margin:2px; margin-left: 32px;">
                    <v-chip v-for="ucitel,index in myData.vyucujuci" :key="index"  :style="getChipColor(index)" @click = "editVyucujuci = ucitel.id; menoVyucujuci = ucitel.priezvisko; naozajUlozit = 0">
                        {{ ucitel.priezvisko }} 
                    </v-chip>
                </v-row>
            </v-card-text>
            <v-card-text style="margin:2px">
                <h3>
                    Hodnotenie predmetu {{ myData.predmet_nazov }}, z ktorého som získal(a):  {{ myData.znamka }}
                </h3>
            </v-card-text>
            <v-card-text>
                <v-row v-for="otazka, index in myData.otazky" :key="index">
                    <v-card :style="striedajBackground(index)" style="width:100%" elevation="0">
                        <v-card-text>
                            <h4>
                                {{index+1}}. {{otazka.otazka}} (vôbec nesúhlasím - úplne súhlasím)
                            </h4>
                        </v-card-text>
                        <v-card-text>
                            <v-row style="margin:5px">
                                <v-spacer />
                                <v-rating :color="striedajColor(index)" length="5" v-model="myData.otazky[index].hodnotenie" @click = "naozajUlozit = 0"
                                        size="compact" style="scale:1.5" clearable/>
                                <v-spacer />
                            </v-row>
                            <v-row style="margin:5px">
                                <v-btn size="small" variant="outlined" @click="myData.otazky[index].hodnotenie = -1">Neposúditeľné</v-btn>
                                <v-spacer />
                                <v-btn v-if="editOtazka != otazka.id" size="small" variant="outlined" @click="editOtazka = otazka.id">komentár</v-btn>                                                            
                            </v-row>
                            <v-row v-if="editOtazka == otazka.id" style="margin:5px;margin-top:10px">
                                <v-textarea rows="5" label="Komentár k hodnoteniu" 
                                    v-model="myData.otazky[index].komentar">                                                                
                                </v-textarea>
                            </v-row>
                            <v-row v-if="editOtazka == otazka.id" style="margin:5px">
                                <v-btn size="small" variant="outlined" @click="editOtazka = -1">OK</v-btn>                                                                                                                        
                            </v-row>
                            <v-row v-if="editOtazka != otazka.id && otazka.komentar.length>0" style="margin:5px">
                                <v-col cols=12>
                                    <v-card variant="outlined">
                                        <v-card-text>
                                            <v-row style="margin:5px">                                                                    
                                                <p>{{otazka.komentar}}</p>
                                                <v-spacer />
                                                <v-btn size="small" variant="outlined" @click="myData.otazky[index].komentar =''; ">Vymaž</v-btn>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-card-text>                                             

                    </v-card>
                </v-row>


            </v-card-text>
            <v-card style="width:100%; background-color: #2E7D32;" elevation="0" v-if="naozajUlozit==0">
                <v-row style="margin:12px">
                    <v-spacer />
                    <v-btn color="white" variant="outlined" @click="sendEval()">Odoslať <span v-if="menoVyucujuci.length>0">&nbsp; (hodnotený: {{menoVyucujuci}})&nbsp;</span>- bez možnosti zmeny</v-btn>     
                    <v-spacer />
                </v-row>
            </v-card>
            <v-card style="width:100%; background-color: #2E7D32;" elevation="0" v-if="naozajUlozit==1">
                <v-card-title>
                    <p style="color:white">Naozaj chcete odoslať?</p>
                    <p style="color:white" v-if="pocetNehodnotenych >0 ">Nevyplnili ste všetky hodnotenia - chýba: {{ pocetNehodnotenych }}</p>
                </v-card-title>
                <v-row style="margin:12px">                   
                    <v-spacer />
                    <v-btn color="white" variant="outlined" @click="sendEval()">Naozaj odoslať <span v-if="menoVyucujuci.length>0">&nbsp; (hodnotený: {{menoVyucujuci}})&nbsp;</span>- bez možnosti zmeny</v-btn>     
                    <v-spacer />
                </v-row>
            </v-card>
            <v-card style="width:100%; background-color: #2E7D32;" elevation="0" v-if="naozajUlozit==2">
                <v-card-title>
                    <span style="color:white">Nezadali ste vyučujúceho, hodnotenie nemožno uložiť.</span>
                </v-card-title>
                <v-row style="margin:12px">                   
                    <v-spacer />
                    <v-btn color="white" variant="outlined" @click="sendEval()">Naozaj odoslať <span v-if="menoVyucujuci.length>0">&nbsp; (hodnotený: {{menoVyucujuci}})&nbsp;</span>- bez možnosti zmeny</v-btn>     
                    <v-spacer />
                </v-row>
            </v-card>

        </v-card>
    </div>
</template>

<script>
// import router from '@/router/index.js'
import axios from '../../axios-auth.js'

export default {
    data() {
        return {
            myData : null,
            predmet_id: -1,
            typ_dot: '',
            obdobie: '',
            editOtazka: -1,
            editVyucujuci: -1,
            menoVyucujuci: '',
            naozajUlozit: 0,
            pocetNehodnotenych: 0
        }
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.$store.commit('setFeedback', null)
            this.predmet_id = this.$route.params.predmet_id
            this.typ_dot =  this.$route.params.typ_dot
            this.obdobie =  this.$route.params.obdobie
            this.getQuestions()            
        },
        getQuestions() {
            axios.get('/get-evaluation-questions/'+this.predmet_id+'/'+this.typ_dot+'/'+this.obdobie, this.$store.getters.getAxiosConfig)
            .then(res => {
                if (res.data.message == 'OK') {
                    this.myData = res.data
                    if (this.myData.vyucujuci.length == 1) {
                        this.editVyucujuci = this.myData.vyucujuci[0].id; 
                        this.menoVyucujuci = this.myData.vyucujuci[0].priezvisko; 
                    }
                }else {
                    this.$store.commit('setFeedback', res.data.message)
                } 
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        striedajBackground(index3) {
           return index3 %2==0 ? 'background-color:#FFFFFF' : 'background-color:#E8F5E9'
        },
        striedajColor(index3) {
           return index3 %2==0 ? '#2E7D32':'#2E7D32'
        },
        getChipColor(_index) {
            return (this.myData.vyucujuci[_index].id == this.editVyucujuci) ? 'background-color:#2E7D32;color:white;': ''
        },
        sendEval() {
            if (this.myData.vyucujuci.length > 0 && this.menoVyucujuci.length<1) {
                this.naozajUlozit = 2
                return
            }
            if (this.naozajUlozit == 0 ) {
                this.pocetNehodnotenych = 0;
                for(let i=0;i<this.myData.otazky.length;i++) {
                    if (this.myData.otazky[i].hodnotenie == -1) this.pocetNehodnotenych += 1 
                }
                this.naozajUlozit = 1
                return
            }
            this.naozajUlozit = 3

            const _otazky = []
            for(let i=0; i<this.myData.otazky.length; i++) {
                _otazky.push({
                        otazka_id: this.myData.otazky[i].id,
                        hodnotenie: this.myData.otazky[i].hodnotenie,
                        komentar: this.myData.otazky[i].komentar
                    }
                )
            }
            const _data = {
                obdobie: this.obdobie,
                teacher_id: this.editVyucujuci,
                typ_dot : this.typ_dot,
                predmet_id: this.predmet_id,
                odpovede: JSON.stringify(_otazky)
            }

            axios.post('/add-evaluation-answers', _data, this.$store.getters.getAxiosConfig)
            .then(res => {
                console.log(res.data)
                if (res.data.message == 'OK') {
                    this.$router.push({name:'evaluation', params: {}}) 

                } else {
                    this.naozajUlozit = 0
                    this.$store.commit('setFeedback', res.data.message)
                    this.gototo('start_page')
                }                 
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
                this.gototo('start_page')
            })
        },
        gototo(_id) {
            const myid = document.getElementById(_id);
            let position = myid.getBoundingClientRect()
            window.scrollTo(position.left, 0);
        },

    }
}
</script>

<style>

</style>